import React from "react";

// Form Field - Standard input field with forwardRef support
export const FormField = React.forwardRef(
  (
    {
      label,
      type = "text",
      value,
      onChange,
      error,
      placeholder,
      required = false,
      className = "",
      children,
      ...props
    },
    ref
  ) => (
    <div className={`mb-4 ${className}`}>
      {label ? (
        <label className="block text-sm font-medium text-brand-charcoal mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      ) : null}
      {type === "select" ? (
        <select
          ref={ref}
          value={value}
          onChange={onChange}
          className={`
          w-full px-4 py-3 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal
          focus:ring-2 focus:ring-brand-gold-ink focus:border-transparent 
          transition-all duration-200
          ${error ? "border-red-300" : ""}
        `}
          {...props}
        >
          {children}
        </select>
      ) : (
        <input
          ref={ref}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`
          w-full px-4 py-3 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal
          focus:ring-2 focus:ring-brand-gold-ink focus:border-transparent 
          transition-all duration-200
          ${error ? "border-red-300" : ""}
        `}
          {...props}
        />
      )}
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  )
);

// Add display name for better debugging
FormField.displayName = "FormField";

export default FormField;
